<div class="chat-container">
  <div class="mascot-container">
    <img src="assets/images/mascot/MIRA HR Mascot-03.png" alt="MIRA HR Assistant" class="mascot-image"/>
  </div>

  <div class="chat-wrapper">
    <div class="custom-chat-panel">
      <div class="custom-chat-header">HR Policy Assistant</div>

      <div class="custom-chat-messages" #messagesContainer>
        <ng-container *ngFor="let msg of messages">
          <!-- User messages: plain text bubble on the right -->
          <div *ngIf="msg.reply" class="user-message-row">
            <div class="user-bubble">
              <span class="user-sender">{{ msg.sender }}</span>
              <p class="user-text">{{ msg.text }}</p>
            </div>
          </div>

          <!-- AI messages: markdown-rendered bubble on the left -->
          <div *ngIf="!msg.reply" class="ai-message-row">
            <img *ngIf="msg.avatar" [src]="msg.avatar" class="ai-avatar" alt="MIRA"/>
            <div class="ai-bubble">
              <span class="ai-sender">{{ msg.sender }}</span>
              <div class="ai-body" [innerHTML]="toHtml(msg.text)"></div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="custom-chat-form">
        <nb-chat-form
          (send)="onSend($event)"
          [showButton]="true"
          [dropFiles]="false"
          placeholder="Type a message">
        </nb-chat-form>
      </div>
    </div>
  </div>
</div>
